import { formatPrice, updateCartQuantity } from '@nova/utils'

const $quantityInputs = document.querySelectorAll('.cart-item__quantity')

for (const $input of $quantityInputs) {
  $input.addEventListener('changeQuantityStarted', handleQuantityChange)
}

function updateItemPrices(currentItemHtml, currentItem) {
  const regularPriceHtml = currentItemHtml.querySelector(
    '.cart-item__regular-price',
  )
  const compareAtPriceHtml = currentItemHtml.querySelector(
    '.cart-item__compare-at-price',
  )
  const currentQuantity = currentItem.quantity

  // update regular price
  regularPriceHtml.innerHTML = formatPrice(currentItem.final_line_price)

  // update compare at price
  if (compareAtPriceHtml) {
    const compareAtPriceValue =
      Number.parseInt(compareAtPriceHtml.dataset.price) *
      Number.parseInt(currentQuantity)
    compareAtPriceHtml.innerHTML = formatPrice(compareAtPriceValue)
  }
}

function updateSubtotalPrice(newPrice) {
  const subtotalHtml = document.querySelector('.summary__total-price')
  subtotalHtml.innerHTML = formatPrice(newPrice)
}

async function updateQuantity(itemKey, quantity) {
  const data = await updateCartQuantity(
    [
      {
        id: itemKey,
        quantity,
      },
    ],
    false,
  )
  document.dispatchEvent(new CustomEvent('nova:changeQuantityFinished'), {
    bubbles: true,
  })

  return data
}

async function handleQuantityChange(event) {
  const quantity = event.detail.value
  const cartData = await updateQuantity(event.detail.key, quantity)
  const currentItemHtml = event.target.closest('.cart-item')
  const currentItemData = cartData.items.find(
    (item) => item.key === event.detail.key,
  )

  if (quantity === 0) {
    currentItemHtml.remove()
  } else {
    updateItemPrices(currentItemHtml, currentItemData)
    updateSubtotalPrice(cartData.items_subtotal_price)
  }
}
